module.exports = __webpack_public_path__ + "static/media/logo_gol_y_futbol_claro.eae89989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_gol_y_futbol_claro.svg
// module id = 558
// module chunks = 0